module.exports = __webpack_public_path__ + "img/big.fc615d0a.jpg";